<template>
    <paper v-loading="loading"
           class="dispatch-center"
           id="visual-map-layout"
           style="padding-left: 0; position: relative">
        <el-main v-loading="mainLoading"
                 class="main-loading">
            <m-pane ref="tablePage"
                    :config="config"
                    :pickerConfig="config.pickerConfig"
                    :totalData="totalData"
                    :totalTargetData="totalTargetData"
                    :sourceRootData="sourcePointData"
                    :mulSourceSel="true"
                    :pageTotal="pageTotal"
                    :searchTotalTitle="searchTotalTitle"
                    :optionNum="optionNum"
                    :loading="loading"
                    :targetTableLoading="targetTableLoading"
                    :columnNum="columnNum"
                    searchId="visualMapLayoutQuery"
                    pageID="visualMapLayout"
                    @searchChange="searchChange"
                    @searchSet-change="searchSetchange"
                    @search-list-change="searchListChange"
                    @getTableColumnConf="getTableColumnConf">
                <div slot="table-module-btn">
                    <reportExport #default="{ submit }"
                                  reportCode="REPORT_MAP_LAYOUT">
                        <el-tooltip effect="dark"
                                    content="导出"
                                    placement="bottom">
                            <span class="mgr-10 bigData-btn-export">
                                <el-button icon="icon-daochu"
                                           size="mini"
                                           @click="exportFile(submit)"></el-button>
                            </span>
                        </el-tooltip>
                    </reportExport>
                </div>
                <div style="height: 100%"
                     slot="map">
                    <div :id="mapId"
                         :style="{ height: '100%', width: '100%' }"></div>
                </div>
            </m-pane>
        </el-main>
        <!-- 地图点悬浮表格 -->
        <vdc-point-task-window :mapId="mapId"
                               v-show="showPointTaskWindow"
                               :controller="vdcPointTaskWindowController">
            <div slot="window-content">
                <vdc-tasks-Info-table :controller="vdcTasksInfoTableController"
                                      :config="config"
                                      :tableColumnConf="tableColumnConf">
                </vdc-tasks-Info-table>
            </div>
        </vdc-point-task-window>
        <!-- 右下角状态列表 -->
        <dot-hints @setCircle="setCircle"/>
        <!-- 订单明细 -->
        <div class="headerTop"
             :style="topStyle">
            <!-- 订单汇总 -->
            <waybill-info :orderTotalNums="orderTotalNums"
                          :allselectedPoints="allselectedPoints"
                          :allOrderNums="allSelectedTasks"/>
            <!-- 圈选切换 -->
            <map-drawing-switch class="mgl-5"
                                :mapController="mapController"/>
            <!-- 圆点设置 -->
            <circleDialog ref="circleDialog" @setCircleSize="setCircleSize"/>                    
            <!-- 路径切换 -->
            <polyline-switch class="mgl-5"
                             :mapController="mapController" />
            <el-button type="primary"
                       class="mgl-5"
                       @click="ShowDialog">规划路线</el-button>
            <div class="swBox">
                <el-switch v-model="showValue"
                           active-text="展示位详情"
                           @change="showPointTaskWindow = !showPointTaskWindow"
                           class="mgl-5">
                </el-switch>
            </div>

            <!-- 订单货运列表 -->
            <order-waybill-list ref="orderWaybillList"
                                @on-click="allSelect"
                                @allSelect="allSelect"
                                @clearMapLine="clearMapLine"
                                @clearTasks="clearMapFlag"
                                :mapController="mapController"
                                :sourceRootData="orderPrams"
                                :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                                :siteList='siteList'/>
         <el-button plain class="clearbtn" @click="clearPoint">清空已选</el-button>                        
        </div>
        <!-- 快消单排车 -->
        <quick-cancellation-dialog :quickCancellationVisiable.sync="quickCancellationVisiable"
                                   v-if="quickCancellationVisiable"
                                   :flag="flag"
                                   ref="quickDialog"
                                   @AdmittOk="handleScheduleOk">
        </quick-cancellation-dialog>
        <car-scheduling-dialog :carrierDisabled="true"
                               :taskDataList="taskDataList"
                               ref="carScheduling"
                               label-position="right"
                               :RwCarVisiable.sync="arrangeSubmVisi"
                               v-if="arrangeSubmVisi"
                               :inOutType="currInOutType"
                               @AdmittOk="handleScheduleOk" />
    </paper>
</template>
<script>
import { mapState } from 'vuex';
import QuickCancellationDialog from '@/modules/transport/otp/components/dialog/QuickCancellationDialog';
import carSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import mPane from './mPanel';
import _ from 'lodash';
import config from './visualMapLayoutConfig.js';
import paper from '@/components/core/paper/Paper';
import { mutations, state } from './store.js';
import {
    getOrdersApi,
    saveCarArrange,
    getLinePlanQuery,
    getWhiteListApi
} from '../../../api/visualMapLayout';
import formatTime from '@/utils/common.js';
import { MapController } from './map/mapController';
import { tasksAt } from './utils/helpers';
import { MapVdcLogic } from './map/mapVdcLogic';
import MapDrawingSwitch from './components/MapDrawingSwitch';
import DotHints from './components/DotHints';
import VdcPointTaskWindow, {
    VdcFloatWindowController
} from './components/FloatWindow';
import VdcTasksInfoTable, {
    VdcTasksInfoTableController
} from './components/TasksInfoTable';
import WaybillInfo from './components/WaybillInfo';
import OrderWaybillList from './components/OrderWaybillList';
import PolylineSwitch from './components/PolylineSwitch';
import circleDialog from './dialog/circleDialog';
import reportExport from '@/components/lots/reportExportPlugin';
import { getRandomColor } from './utils/colors';

export default {
    name: 'visualMapLayout',
    components: {
        MapDrawingSwitch,
        DotHints,
        QuickCancellationDialog,
        carSchedulingDialog,
        VdcPointTaskWindow,
        VdcTasksInfoTable,
        mPane,
        paper,
        WaybillInfo,
        circleDialog,
        OrderWaybillList,
        PolylineSwitch,
        reportExport
    },
    data () {
        const mapId = 'BMap-' + parseInt(Date.now() + Math.random());
        return {
            showFlag: true,
            flag: '',
            orderTotalNums: [], // 总运单
            quickCancellationVisiable: false,
            tasksAtPoints: [],
            config: config,
            loading: false,
            targetTableLoading: false,
            orderPrams: {}, // 订单列表参数
            optionNum:
                'DELIVERY_TYPE,TRANSPORT_STATUS,OTP_TMS_PROCUREMENT_CHANNEL',
            sourcePointData: [], // 所有坐标数据
            totalData: [], // 浮动框TK单数据
            totalTargetData: [], // 左侧查询出来的数据
            mapId,
            mapController: new MapController(mapId, { isPolyline: false }),
            selectedPoints: [], // 已选择的点
            selectedTasks: [], // 已选TK单
            taskDataList: [],
            // 悬浮框处理 包含可拖拽
            vdcPointTaskWindowController: new VdcFloatWindowController(),
            vdcTasksInfoTableController: new VdcTasksInfoTableController(),

            pageTotal: 100,
            searchParams: {},
            exportParams: {},
            isFirstSearch: true,
            searchTotalTitle: config.table.searchTotalTitle, // 高级搜索
            mainLoading: false,
            columnNum: 100, // 设置列配置最高多少项
            tableColumnConf: '',
            showPointTaskWindow: false,
            showValue: false,
            arrangeSubmVisi: false,
            trainList: [],
            // cpnoNotLine: []
            siteList: [],
            appointmentSiteCodeWhiteList: [] // 预约强控白名单
        };
    },
    computed: {
        // 排车回调参数
        combinedSelectedTasks: function () {
            if (!this.mapController.mapLogic) {
                return [];
            }
            return this.mapController.mapLogic.combineSelectedTasks(
                this.selectedTasks
            );
        },
        // 获取浮动框的数据
        totalDataAndTotalTargetData: function () {
            return this.totalData;
        },
        // 选中当前TK单
        allSelectedTasks: function () {
            return this.selectedTasks;
        },
        // 选中当前经纬度
        allselectedPoints: function () {
            return this.selectedPoints;
        },
        ...mapState({
            currentTenant: (state) => state.currentTenant,
            supplier: state => state.supplier,
            user: state => state.user
        }),
        topStyle () {
            const windowWidth = window.innerWidth;
            const top = windowWidth > 1200 ? '60px' : '88px';
            return { top };
        },
        reSetFlag () {
            return state.reSetData;
        },
        currInOutType: function () {
            return this.combinedSelectedTasks[0] && this.combinedSelectedTasks[0].inOutType;
        },
    },
    methods: {
        // 地图线路绘制
        updateRoute (id, points, loadData, color) {
            this.mapController.addRoute(
                id,
                { lng: points[0].lng || 0, lat: points[0].lat || 0 }, // 起始点
                points,
                loadData,
                {
                    color
                }
            );
        },
        // 全选/单选
        allSelect (val, index, item) {
            this.clearMapFlag();
            this.orderTotalNums = []; // 清空汇总
            this.mapController.removecandwPoitn();
            this.mapController.removecandwLabel();
            this.mapController.removeRoute(this.mapId); // 单独指定ID 单独清除规划线后路径
            // this.cpnoNotLine = [];

            item.forEach((item) => {
                this.loading = true;
                if (val === true) {
                    item.color = getRandomColor();
                    item.checked = true;
                    item.disabled = false;
                    // 绘制线路
                    getLinePlanQuery({ dispatchNo: item.dispatchNo })
                        .then((res) => {
                            if (res && +res.code === 0 && res.data) {
                                this.mapController.selectId.set(item.id, res.data[0].id);
                                const loadData = (res.data[0].loadQueueObj || []).concat(res.data[0].unloadQueueObj || []);
                                const lngAndlatPoint = loadData.map(({ longitude, latitude }) => ({ lng: longitude, lat: latitude }));
                                this.updateRoute(
                                    res.data[0].id,
                                    lngAndlatPoint,
                                    loadData,
                                    item.color
                                );
                                this.loading = false;
                            }
                        })
                        .catch(() => {
                            // this.cpnoNotLine.push(item.dispatchNo);
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                message: `<div>
                            <span>该发车单：${item.dispatchNo} 无法规划线路</span>
                              <a id="copyNoTLine" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                        </div>`,
                                type: 'warning',
                                duration: 2000
                            });
                            document
                                .getElementById('copyNoTLine')
                                .addEventListener('click', () => {
                                    this.copyText(
                                        document.body,
                                        item.dispatchNo,
                                        false
                                    );
                                });
                            this.loading = false;
                        });
                } else {
                    item.color = '';
                    item.checked = false;
                    this.mapController.selectId.delete(item.id);
                    // 根据ID 清除对应线路
                    getLinePlanQuery({
                        dispatchNo: item.dispatchNo
                    }).then((res) => {
                        if (res.data.length > 0 && res.data) {
                            this.mapController.removeRoute(res.data[0].id);
                            this.loading = false;
                            // this.cpnoNotLine = [];
                        } else {
                            this.loading = false;
                            return false;
                        }
                    });
                }
            });
            // 勾选时 收集无法规划线路发车单号
            // setTimeout(() => {
            //     if (val && this.cpnoNotLine.length > 0) {
            //         this.$message({
            //             dangerouslyUseHTMLString: true,
            //             message: `<div>
            //                 <span>该发车单：${this.cpnoNotLine} 无法规划线路</span>
            //                   <a id="copyNoTLine" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
            //             </div>`,
            //             type: 'warning',
            //             duration: 2000
            //         });
            //         document
            //             .getElementById('copyNoTLine')
            //             .addEventListener('click', () => {
            //                 this.copyText(
            //                     document.body,
            //                     [...this.cpnoNotLine],
            //                     false
            //                 );
            //             });
            //     }
            // }, 2000);
        },
        // 导出
        exportFile (submit) {
            this.isFirstSearch &&
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.exportParams,
                carrierVisibleFlag: 'Y', //lsp排车标识
                carrierCode: this.supplier.supplierCode,
                tenantCode: this.currentTenant.tenantCode // 用户ID
            });
            this.isFirstSearch = false;
        },
        // 路线规划校验
        ShowDialog () {
            if (!this.combinedSelectedTasks.length) {
                return this.$message.warning('请先选择运输单');
            }
            //非快消单
            if (this.combinedSelectedTasks.every(s => { return s.projectClassify !== 'QCO' })) {
                this.taskDataList = this.combinedSelectedTasks
                const setVal = () => {
                    this.arrangeSubmVisi = true;
                    const params = {
                        carrierName: this.taskDataList[0].carrierName,
                        carrierCode: this.taskDataList[0].carrierCode,
                        supplierCode: this.taskDataList[0].carrierCode,
                        transType: this.taskDataList[0].procurementChannel,
                        tranName: this.taskDataList[0].procurementChannelName,
                        siteCode: this.taskDataList[0].siteCode,
                        transUnitName: this.taskDataList[0].transUnitName,
                        transUnitCode: this.taskDataList[0].transUnitCode,
                        paymentTerms: this.taskDataList[0].paymentTerms,
                        transportContractNo: this.taskDataList[0].transportContractNo
                    };
                    this.$nextTick(() => {
                        this.$refs.carScheduling.AdmittRuleForm.carrierName = this.taskDataList[0].carrierName;
                        this.$refs.carScheduling.AdmittRuleForm.companyCode = this.taskDataList[0].companyCode;
                        this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.taskDataList.filter(item => item.lineCode).map(item => item.lineCode);
                        this.$refs.carScheduling.AdmittRuleForm.siteCodeList = this.taskDataList.filter(item => item.siteCode).map(item => item.siteCode);
                        this.$refs.carScheduling.getAdvanceValueLists(params);
                    });
                };
                const flag = this.taskDataList.find((item, index, arr) => item.carrierCode !== arr[0].carrierCode);
                if (flag) {
                    this.$message.warning('同一承运商的运单才能排车');
                    return false;
                }
                // 点击了排车，已下发供应商
                setVal();
                this.arrangeSubmVisi = true;
            }
            //快消单
            else if (this.combinedSelectedTasks.every(s => { return s.projectClassify === 'QCO' })) {
                this.quickCancellationVisiable = true;
            }
            //混排
            else {
                return this.$message.warning('快销单不允许混排!');
            }
        },
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        // 排车成功回调
        handleScheduleOk (data) {
            if (!data.state) return
            data = Object.assign({}, data.data, {
                transportList: this.combinedSelectedTasks,
                mapDispatch: true,
                carrierVisibleFlag: 'Y', //lsp排车标识
                carrierCode: this.supplier.supplierCode,
                carrierName: this.supplier.supplierNameCn,
            });
            if (this.$refs.quickDialog) {
                this.$refs.quickDialog.saveLoading = true;
            }
            saveCarArrange(data)
                .then((res) => {
                    if (this.$refs.quickDialog) {
                        this.$refs.quickDialog.saveLoading = false;
                    }
                    this.arrangeSubmVisi = false
                    if (res && +res.code === 0) {
                        const genDispatchNo =
                            res.data.indexOf(',') < 0
                                ? res.data
                                : res.data.split(',')[0];
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: `<div>
                            <span style="white-space: pre-line;">生成发车单号：${res.data}</span>
                            <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                            <div>线路规划中，请稍后</div>
                        </div>`,
                            type: 'success',
                            duration: 2000
                        });
                        this.clearMapFlag();
                        this.mapController.removecandwPoitn();
                        this.mapController.removecandwLabel();
                        this.retryCount = 0;
                        this.getLineMap(res.data);
                        this.quickCancellationVisiable = false;
                        document
                            .getElementById('copyNo')
                            .addEventListener('click', () => {
                                this.copyText(
                                    document.body,
                                    genDispatchNo,
                                    false
                                );
                            });
                    }
                    this.arrangeSubmVisi = false
                })
                .catch(() => {
                    if (this.$refs.quickDialog) {
                        this.$refs.quickDialog.saveLoading = false;
                    }
                    this.arrangeSubmVisi = false
                });
        },
        // 线路规划
        async getLineMap (dispatchNo) {
            this.loading = true;
            await getLinePlanQuery({ dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    //预排车划线需要线路ID进selectId
                    this.mapController.selectId.set('quick', res.data[0].id);
                    const { loadQueueObj, unloadQueueObj } = res.data[0];
                    const loadData = [...loadQueueObj, ...unloadQueueObj];
                    const longAndLatPoint = loadData.map(({ longitude, latitude }) => ({ lng: longitude, lat: latitude }));
                    this.updateRoute(res.data[0].id, longAndLatPoint, loadData, getRandomColor());
                    if (this.reSetFlag) {
                        this.$refs.orderWaybillList.com === 'WaybillList' && this.$refs.orderWaybillList.$refs.orderList.getDispatcData();
                    }
                    this.loading = false;
                }
            }).catch(() => { this.$message.warning(`排车失败，请重试`); this.loading = false; });
        },
        // 列展示
        getTableColumnConf (data) {
            this.tableColumnConf = data;
        },
        // 初始化地图
        mapInit () {
            this.mapController.initMap();
            this.mapController.useLogic(
                new MapVdcLogic(),
                (mapCtrl, mapVdclogic) => {
                    // 让浮动框可以转换: 地图 Point -> 地图视口 pxiel
                    this.vdcPointTaskWindowController.usePointPixelTranslator(
                        mapCtrl.pointToxPixel.bind(mapCtrl)
                    );

                    // 监听地图移动和缩放，重定位浮动框
                    mapCtrl.onMoveOrZoom(() => {
                        this.vdcPointTaskWindowController.adjustPosition();
                    });

                    // 处理地图选点
                    mapCtrl.onSelectPoints(({ event, points }) => {
                        mapVdclogic.addSelectedPoints(points, mapCtrl, this, this.appointmentSiteCodeWhiteList);
                    });
                    // 鼠标 over 点时，显示浮动框
                    mapCtrl.onPointMouseover((event) => {
                        const tasks = tasksAt(
                            event.point.lat,
                            event.point.lng,
                            this.totalDataAndTotalTargetData
                        );
                        this.vdcTasksInfoTableController.setTasks(tasks);
                        this.vdcPointTaskWindowController.show();
                        this.vdcPointTaskWindowController.moveToInPoint(
                            event.point
                        );
                    });
                    // 鼠标 out 点时，隐藏浮动框
                    mapCtrl.onPointMouseout((event) => {
                        this.vdcPointTaskWindowController.hide(event.point);
                    });
                }
            );
        },
        // 设置圆圈大小
        setCircle () {
            this.$refs.circleDialog.circleVisable = true;
        },
        // 查询区域
        async searchChange (data) {
            // 要求传对应的CodeList，而组件传出有name和code后面如果组件用CodeList就下面这样，但为了config配置保持一致
            this.mapController.clearAllPolygons(true);
            const receiverAddress = [
                'receiverProvince',
                'receiverCity',
                'receiverDistrict',
                'receiverTown'
            ];
            const senderAddress = [
                'senderProvince',
                'senderCity',
                'senderDistrict',
                'senderTown'
            ];
            if (data.receiverAddressSelectCode) {
                receiverAddress.forEach((areaCode, index) => {
                    const arr = data.receiverAddressSelectCode.map((item) => item[index]).filter((item) => item);

                    data[areaCode + 'CodeList'] = [...new Set(arr)];
                });
            }
            if (data.senderAddressSelectCode) {
                senderAddress.forEach((areaCode, index) => {
                    const arr = data.senderAddressSelectCode.map((item) => item[index]).filter((item) => item);
                    data[areaCode + 'CodeList'] = [...new Set(arr)];
                });
            }
            // 客户数据处理
            if (data.customerNameList) {
                const name = data.customerNameList.split(',');
                const code = data.customerCodeList.split(',');
                const address = data.businessAddress
                    ? data.businessAddress.split(',')
                    : [];
                const resArr = [];
                name.forEach((name, index) => {
                    const obj = {};
                    obj.ebcuNameCn = name;
                    obj.pmCode = code[index];
                    obj.businessAddress = address[index];
                    resArr.push(obj);
                });
                data.customerInfoList = resArr;
            }
            // 仓库数据处理
            if (data.cdwhName) {
                const name = data.cdwhName.split(',');
                const code = data.whCode.split(',');
                const address = data.eblcDetailAddress.split(',');
                const lng = data.cdwhLongitude.split(',');
                const lat = data.cdwhLatitude.split(',');
                const resArr = [];
                name.forEach((name, index) => {
                    const obj = {};
                    obj.cdwhName = name;
                    obj.whCode = code[index];
                    obj.eblcDetailAddress = address[index];
                    obj.cdwhLongitude = lng[index];
                    obj.cdwhLatitude = lat[index];
                    resArr.push(obj);
                });
                data.warehouseInfoList = resArr;
            }

            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime) {
                data.beginDate = '';
                data.endDate = '';
            }
            const startTime = data.beginDate || 0;
            const endTime = data.endDate || 0;
            const timeDifference =
                new Date(endTime).getTime() - new Date(startTime).getTime();
            if (timeDifference > 32 * 24 * 60 * 60 * 1000) {
                return this.$message.warning(
                    '按时间查询时，查询时间跨度不可超过一个月！'
                );
            }
            data.customerOrderNoList = data.custOrderNoList
                ? data.custOrderNoList.split(',')
                : [];

            data.siteCodeList = data.siteCodeList
                ? data.siteCodeList.split(',')
                : [];

            data.taskNos = data.taskNo
                ? data.taskNo.split(',')
                : [];
            //识别操作系统字段
            data.operateSystem = "LSP"
            // 导出参数 放在校验后 防止阻塞
            this.exportParams = Object.assign({}, data);
            // 校验规则
            if (data.customerOrderNoList.length > 100) {
                return this.$message.warning('一次性最多输入100个客户订单号');
            }
            if (!data.taskStatusList.length) {
                return this.$message.warning('运单状态不能为空');
            }

            if (!data.customerNameList && !data.cdwhName) {
                return this.$message.warning('客户 和 仓库 不可同时为空');
            }
            // 删除多余参数
            delete data.custOrderNo;
            delete data.customerCodeList;
            delete data.createTime;
            delete data.cdwhLatitude;
            delete data.cdwhLongitude;
            delete data.cdwhName;
            delete data.eblcDetailAddress;
            delete data.siteNameList;
            delete data.customerNameList;
            delete data.whCode;
            delete data.custOrderNoList;
            delete data.receiverAddressSelectCode;
            delete data.senderAddressSelectCode;
            delete data.taskNo;

            this.searchParams = Object.assign({}, this.searchParams, data);
            mutations.add(this.searchParams); // 左侧列表接口需要参数
            mutations.clearOlist(true); // 清空运单列表的已选项
            // 查询
            await getOrdersApi(this.searchParams)
                .then((resp) => {
                    this.searchParams = [];
                    if (resp && +resp.code === 0) {
                        this.clearMapFlag(); // 清除海量点
                        this.mapController.removecandwPoitn(); // 清除客户仓库图标
                        this.mapController.removecandwLabel(); // 清除label 地图序号
                        this.mapController.removeAllRoutes(); // 清除导航路径
                        this.sourcePointData = resp.data.transportList || []; // 查询所有数据
                        this.totalData = resp.data.transportList; // 坐标Tips 信息
                        this.orderTotalNums = resp.data.transportList;
                        this.mapController.run((mapCtrl, logic) => {
                            mapCtrl.markLabel(2, this.sourcePointData); // 地图序号
                            mapCtrl.drawPoints(
                                ...logic.seperatePointsFromTasks(
                                    this.sourcePointData
                                )
                            ); // 海量点打点
                            mapCtrl.markPoints(
                                1,
                                (resp.data.customerList || []).concat(
                                    resp.data.wareHouseList || []
                                )
                            ); // 仓库客户图标
                        });
                    }
                })
                .catch(() => { });
        },
        // 清除星星点点
        clearMapFlag () {
            this.selectedTasks = []; // 清空task
            this.selectedPoints = []; // 清空坐标
            this.mapController.run((mapCtrl, logic) => {
                mapCtrl.drawPoints(...logic.seperatePointsFromTasks([])); // 清空圆圈
                mapCtrl.clearSelectedPoints(); // 清除星星
            });
        },
        // 发车单查询只清除线路规划
        clearMapLine () {
            this.mapController.removeAllRoutes();
        },
        // 清除取消行选中状态时已经选中的星星数据
        clearTasks () {
            this.selectedTasks = [];
        },
        // 搜索选项选择
        searchListChange ({ value }, data) {
            if (value === 'siteNameList') {
                this.siteList = data.siteCodeList ? data.siteCodeList.split(',') : [];
            }
        },
        // 高级搜索选项选择
        searchSetchange (data) {
            if (data.siteCodeList) {
                this.siteList = data.siteCodeList ? data.siteCodeList.split(',') : [];
            }
        },
         // 清空已选
         clearPoint () {
            this.selectedTasks = [];
            this.selectedPoints = [];
            this.mapController.run((mapCtrl, logic) => {
                mapCtrl.clearSelectedPoints(); // 清除星星
            });
        },
       // 设置圆圈大小
        setCircleSize (val) {
            const params = _.clone(this.$refs.tablePage.$refs.searchList.searchData);
            this.setInKey('circleSize', val);
            this.searchChange(params);
        },

        // 根据账号配置存储浏览器数据
        setInKey (key, val) {
            const userCode = this.user.userCode;
            let allUserData = {};
            try {
                // 获取现有的所有用户数据
                const existingData = localStorage.getItem(key);
                if (existingData) {
                    allUserData = JSON.parse(existingData);
                }
            } catch (error) {
                // 如果解析失败，使用空对象
                allUserData = {};
            }
            // 根据当前用户账号存储数据
            allUserData[userCode] = val;
            // 保存所有用户数据
            localStorage.setItem(key, JSON.stringify(allUserData));
        },
        // 强制预约限制白名单
        async getSiteCodeWhiteList ({ type }) {
            await getWhiteListApi({ type }).then(res => {
                if (res && +res.code === 0) {
                    this.appointmentSiteCodeWhiteList = res.data;
                }
            });
        },
    },
    mounted () {
        // 强制预约限制白名单
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
        this.mapInit();
    },
    activated () {
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
    }
};
</script>
<style lang="less">
@import './visualMapLayout.less';
</style>
